export var RelayEventType;

(function (RelayEventType) {
  RelayEventType["CLIENT_CLOSED"] = "client_closed";
  RelayEventType["HOST_CLOSED"] = "host_closed";
})(RelayEventType || (RelayEventType = {}));

export function isRelayEvent(obj) {
  return obj.eventType !== undefined;
}